import React, { useEffect, useState } from "react";
import './../webcss/invoice.css';
import { POST_FINO_TRANSACTION_INVOICE } from './../Utils/appConstants';
import { getUTCToLocalDateTimeFormat } from './../Utils/function';
import { dmtDetailStatus } from './../Utils/Common';
import { postRequest } from './../Utils/AppApi';
import { useHistory } from "react-router-dom";

function Invoice(props) {
    const history = useHistory();
    const [apiName, setApiName] = useState('');
    const [idata, setData] = useState({});
    const [isPrintButton, setPrintButton] = useState(true);
    const [isDetail, setDetail] = useState([]);
    const [invoiceDataModal, setInvoiceDataModal] = useState(false);

    const print = () => {
        setPrintButton(false);
        setTimeout(() => {
            window.print();
        }, 100);
    };

    const handleInvoice = (transactionId) => {
        let payload = { transactionId: transactionId };

        postRequest(`${apiName}`, payload, history)
            .then((response) => {
                if (response.success === true) {
                    setData(response.data);
                    setDetail(response.data.dmttransactiondetails || []);
                }
            })
            .catch(() => {
                setData({});
                setDetail([]);
            });
    };

    useEffect(() => {
        setApiName(POST_FINO_TRANSACTION_INVOICE);
    }, [props.merchantName]);

    useEffect(() => {
        if (apiName) handleInvoice(props.transactionId);
    }, [apiName]);

    const handleHideModal = () => props.onClose && props.onClose();

    return (
        <div className="container-fluid border border-default p-3">
            <div className="row">
                <div className="col-12 col-lg-12">

                    {/* Customer + Beneficiary Section */}
                    <div className="row">
                        <div className="col-sm-6">
                            <div>
                                <span className="text-sm text-grey-m2 align-middle">Customer Name : </span>
                                <span className="text-600 text-110 text-blue align-middle">
                                    {idata?.finocustomerlists?.customerName}
                                </span>
                            </div>

                            <div>
                                <span className="text-sm text-grey-m2 align-middle">Customer Mobile : </span>
                                <span className="text-600 text-110 text-blue align-middle">
                                    {idata?.finocustomerlists?.customerMobile}
                                </span>
                            </div>

                            <div className="text-grey-m2">
                                <div className="my-1 text-600 text-110 text-blue">Beneficiary</div>
                                <div className="my-1">Bank : {idata?.baneData?.bankName}</div>
                                <div className="my-1">IFSC : {idata?.baneData?.ifscCode}</div>
                                <div className="my-1">AC : {idata?.baneData?.accountNumber}</div>
                                <div className="my-1">
                                    Name : {idata?.baneData?.isVerified ? idata?.baneData?.beneBankName : idata?.baneData?.beneName}
                                </div>
                                <div className="my-1">
                                    Status : {idata?.baneData?.isVerified ? "Verified" : "Unverified"}
                                </div>
                            </div>
                        </div>

                        {/* Outlet/User Details */}
                        <div className="text-95 col-sm-6 d-sm-flex justify-content-end">
                            <div className="text-grey-m2">
                                <div className="my-2"><i className="fa fa-circle text-blue-m2 text-xs mr-1" />
                                    <span className="text-600 text-90">Outlet : </span>
                                    {idata?.userdetails?.outletName}
                                </div>

                                <div className="my-2"><i className="fa fa-circle text-blue-m2 text-xs mr-1" />
                                    <span className="text-600 text-90">Name : </span>
                                    {idata?.userdetails?.firstName} {idata?.userdetails?.lastName}
                                </div>

                                <div className="my-2"><i className="fa fa-circle text-blue-m2 text-xs mr-1" />
                                    <span className="text-600 text-90">Contact : </span>
                                    {idata?.userdetails?.mobile}
                                </div>

                                <div className="my-2"><i className="fa fa-circle text-blue-m2 text-xs mr-1" />
                                    <span className="text-600 text-90">Address : </span>
                                    {idata?.userdetails?.communicationAddress}
                                </div>

                                {/* ✔ Updated Message Logic */}
                                <div className="my-2">
                                    <i className="fa fa-circle text-blue-m2 text-xs mr-1" />
                                    <span className="text-600 text-90">Message : </span>

                                    {(() => {
                                        const detail = idata?.dmttransactiondetails?.[0];

                                        const msg =
                                            detail?.reason ||
                                            detail?.txstatus_desc ||
                                            idata?.message ||
                                            "";

                                        const lower = msg.toLowerCase();
                                        let colorClass = "text-warning"; // default: pending/initiated

                                        if (lower.includes("success")) {
                                            colorClass = "text-success";
                                        } else if (
                                            lower.includes("fail") ||
                                            lower.includes("error") ||
                                            lower.includes("declined")
                                        ) {
                                            colorClass = "text-danger";
                                        }

                                        return <strong className={colorClass}>{msg}</strong>;
                                    })()}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Transaction Table */}
                    {!idata?.isInsufficientFund && (
                        <>
                            <div className="row text-600 text-white bgc-default-tp1 py-25">
                                <div className="col-12 col-sm-3">Date & Time</div>
                                <div className="col-12 col-sm-3">Transaction ID</div>
                                <div className="col-12 col-sm-3">Amount</div>
                                <div className="col-12 col-sm-3">Bank RRN</div>
                                <div className="col-12 col-sm-3">Status</div>
                            </div>

                            {isDetail.length > 0 ? (
                                isDetail.map((element, key) => (
                                    <div key={key} className="text-95 text-secondary-d3">
                                        <div className="row mb-2 mb-sm-0 py-25">
                                            <div className="col-12 col-sm-3">{getUTCToLocalDateTimeFormat(element.createdAt)}</div>
                                            <div className="col-12 col-sm-3">{element.transactionId}</div>
                                            <div className="col-12 col-sm-3">{element.amount}</div>
                                            <div className="col-12 col-sm-3">{element.bank_ref_num || "-"}</div>
                                            <div className="col-12 col-sm-3">
                                                {element.tx_status ? dmtDetailStatus(element.tx_status) : "-"}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center col-12 py-3">No transaction details available.</div>
                            )}
                        </>
                    )}

                    <div className="row border-b-2 brc-default-l2" />

                    {/* Footer */}
                    <div className="row mt-3 mb-2">
                        <div className="col-12"><strong className="text-center">T&C / Disclaimer</strong></div>
                        <div className="col-12 text-grey-d2 text-95 mt-2">
                            <p>1. Transaction charges are inclusive of GST.</p>
                        </div>
                    </div>

                    <hr />

                    <div>
                        <span className="text-secondary-d1 text-105">
                            This is a computer generated receipt & doesn't require signature
                        </span>


                      {isPrintButton && (
                            <a
                                href="#/"
                                onClick={handleHideModal}
                                className="btn btn-danger mx-1px text-95 float-right mt-3 mt-lg-0"
                                style={{ borderRadius: "6px" }}
                            >
                                <i className="mr-1 fa fa-times-circle text-white" /> Close
                            </a>
                        )}

                        {isPrintButton && (
                            <a href="#/" onClick={() => print()}
                                className="btn bg-white btn-light mx-1px text-95 float-right mt-3">
                                <i className="mr-1 fa fa-print text-primary-m1 text-120 w-2" /> Print
                            </a>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Invoice;
